/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/no-array-index-key */

import { zodResolver } from '@hookform/resolvers/zod';
import { Euro } from '@mui/icons-material';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useMemo } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { FormLine, RoundedButton } from 'src/components/common';
import { TextFieldRHF } from 'src/components/forms/TextFieldRhf';
import useLoadData from 'src/hook/useLoadData';
import {
  Engravings,
  getAdminEngravingsPrice,
  updateAdminEngravingsCoefficients,
} from 'src/services/coefficients';
import { getSettings, updateSettings } from 'src/services/pieces';
import { handleMutation } from 'src/utils/api.utils';
import { DEFAULT_ENGRAVINGS } from 'src/utils/coefficients.utils';
import styled from 'styled-components';
import { z } from 'zod';

export const SetPiecesSettings = () => {
  const { data: settings, onRefresh } = useLoadData(() => getSettings());

  const piecesSettingsSchema = z.object({
    minPriceFrench: z.string(),
    minPriceImport: z.string(),
  });

  type PiecesSettings = z.infer<typeof piecesSettingsSchema>;

  const { handleSubmit, watch, setValue, reset, control } = useForm({
    defaultValues: {
      minPriceFrench: settings?.minPriceFrench ?? '0',
      minPriceImport: settings?.minPriceImport ?? '0',
    },
    mode: 'onSubmit',
    resolver: zodResolver(piecesSettingsSchema),
  });

  const convertMinPriceFromStringToInt = ({
    minPriceFrench,
    minPriceImport,
  }: {
    minPriceFrench: string;
    minPriceImport: string;
  }) => {
    return {
      minPriceFrench: Number.parseFloat(minPriceFrench) ?? 0,
      minPriceImport: Number.parseFloat(minPriceImport) ?? 0,
    };
  };

  const convertMinPriceFromIntToString = ({
    minPriceFrench,
    minPriceImport,
  }: {
    minPriceFrench: number;
    minPriceImport: number;
  }) => {
    return {
      minPriceFrench: minPriceFrench.toString(),
      minPriceImport: minPriceImport.toString(),
    };
  };
  const submit: SubmitHandler<PiecesSettings> = (datas) => {
    handleMutation(
      (data) => updateSettings(convertMinPriceFromStringToInt(data)),
      datas,
      () => {
        onRefresh();
        toast.success('Prix minimum mis à jour');
      },
    );
  };

  useEffect(() => {
    if (settings) {
      reset(convertMinPriceFromIntToString(settings));
    }
  }, [settings, reset]);

  return (
    <Container onBlur={handleSubmit(submit)}>
      <Box component="div">
        <Typography variant="h5">Paramètres des pièces</Typography>
      </Box>

      <Box sx={{ borderBottom: '1px solid #F2F4F7', paddingBottom: '30px' }} component="div">
        <Typography variant="h6">Prix</Typography>
        <Typography color="#273135" fontSize="small">
          Vous pouvez définir le prix minimum d&apos;achat des pièces en France et en importation.
        </Typography>
        <FormLine sx={{ marginTop: 2 }}>
          <Column>
            <Typography color="#273135" fontSize="small">
              Prix minimum en France
            </Typography>
            <TextField
              name="minPriceFrench"
              value={watch('minPriceFrench')}
              onChange={(event) => {
                setValue('minPriceFrench', event.target.value);
              }}
              onBlur={(event) => {
                setValue('minPriceFrench', event.target.value);
              }}
            />
          </Column>
          <Column>
            <Typography color="#273135" fontSize="small">
              Prix minimum en Import
            </Typography>
            <TextField
              name="minPriceImport"
              value={watch('minPriceImport')}
              onChange={(event) => {
                setValue('minPriceImport', event.target.value);
              }}
              onBlur={(event) => {
                setValue('minPriceImport', event.target.value);
              }}
            />
          </Column>
        </FormLine>
      </Box>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  gap: 16,
  flexDirection: 'column',
  padding: '30px',
});

const Column = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});
